import {Directive} from "@angular/core";
import {NG_VALIDATORS, Validator, FormControl} from "@angular/forms";

@Directive({
    selector: "[acceptedFormats]",
    providers: [
        { provide: NG_VALIDATORS, useExisting: FileFormatValidator, multi: true },
    ]
})
export class FileFormatValidator implements Validator {
    static validate(control: FormControl): {[key: string]: boolean} | null {
        let fileName = control.value[0].name;
        let validationFailedResponse = {
          acceptedFile: true
        };
        
        if (!fileName) {
          return null;
        }
  
        let acceptedFileFormats = ["pdf", "txt", "doc", "docx"];
        let segments = fileName.split(".");
        let extension = segments[segments.length - 1];
  
        if(acceptedFileFormats.includes(extension)) {
          return null;
        }
  
        return validationFailedResponse;
    }

    validate(c: FormControl): {[key: string]: boolean} | null {
        return FileFormatValidator.validate(c);
    }
}